// This only carries invite context. The server always validates eligibility.
export function inviteTokenFromRedirect(redirect) {
  if (typeof redirect !== "string") return null;
  const match = /^\/invites\/([a-f0-9]{64})$/.exec(redirect);
  return match ? match[1] : null;
}
